var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatWeDo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.983,
    height: 26.022,
    viewBox: "0 0 27.983 26.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-construction-1741300",
    transform: "translate(0.004 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M26.859,28.682V20.157h0V6.018H26.02v9.233H22.382V10.775h-.839v8.954H17.906V17.49h-.839v2.667h0v4.048H13.429v-4.2H12.59v4.2h0v4.477H11.75V26.444H8.941V9.376h8.125v1.4h-.56v.839h.56v1.367h0a.909.909,0,1,1-1.67-.579l-.706-.455A1.749,1.749,0,1,0,17.9,13.062l-.5-.048h.508v-1.4h.567v-.839h-.567v-1.4h.28V8.536H17.7L8.941,5.577V3.5H4.2V5.459H3.807L.032,8.536H0v.027l0,0,0,0v.807H4.2V26.444H1.4v2.238H0v.839h27.98v-.839ZM5.035,9.972,7.964,12.9,5.035,15.829Zm0-3.674H8.1V8.536H5.035ZM8.1,18.987,5.583,16.468,8.1,13.949Zm0-7.136L5.626,9.376H8.1ZM5.035,17.107l2.771,2.771L5.035,22.648ZM8.1,20.769v5.038L5.583,23.288ZM15.081,8.536H8.941V6.463ZM5.035,4.339H8.1V5.459H5.035ZM1.36,8.536,4.106,6.3H4.2V8.536ZM5.035,23.927l2.517,2.517H5.035V23.927Zm-2.8,3.356h8.674v1.4H2.237v-1.4Zm23.783,1.4H22.382V25.045H26.02Zm0-4.477H22.382V20.568H26.02Zm-3.637-8.114H26.02v3.637H22.382Zm-4.477,4.477h3.637v3.637H17.906Zm-4.477,8.114V25.045h3.638v3.637Zm4.477-3.637h3.637v3.637H17.906Z",
    fill: "#1c1c74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDo4);
export default __webpack_public_path__ + "static/media/whatWeDo4.22949067e53067524aaf70fb00070488.svg";
export { ForwardRef as ReactComponent };